// REACT
import React, {Component} from 'react';

// TRANSLATE
import { translate } from 'react-i18next';

// AXIOS
import axios from 'axios';

// SETTINGS
import Settings from '../../shared/settings'

// STYLES
import styled from 'styled-components';

// COMPONENTS
import Loading from '../../components/loading/loading.component';

// CONTAINERS
import Banner from '../../containers/Banner/banner.container'
import About from '../../containers/About/about.container';
import Preparation from '../../containers/Preparation/Preparation.container';

class DetailsReceips extends Component {
    constructor(){
        super();
        this.state = {
            status: 0,
            data: '',
            dataToBanner: '',
            dataToAbout: ''
        }
    }

    componentDidMount () {
        this.loadData()
    }

    componentWillUpdate(){
        const slug = this.props.match.params.slug;
        const requestLang = window.location.pathname.split('/');
        let lang = requestLang[1];

        if (lang !== this.props.i18n.language) {
            let url = '/'+this.props.i18n.language+'/'+this.props.t('receitas')+'/'+slug;
            this.props.history.replace(url, true)
        }
    }

    loadData(){
        const {
            i18n
        } = this.props;

        const slug = this.props.match.params.slug;
        let url = Settings.server+'/api/v1/recipe/'+slug+'?expand=media&lang='+i18n.language;
        
        axios.get(url)
        .then(
            res => {
                this.setState({
                    dataToBanner: {
                        name: res.data.name ? res.data.name : null,
                        description: res.data.description ? res.data.description : null,
                        banner: res.data.media[2][0] ? res.data.media[2][0] : null,
                        dificulty: res.data.dificulty ? res.data.dificulty : null,
                        number_people: res.data.number_people ? res.data.number_people : null,
                        time: res.data.time ? res.data.time : null,
                        region: res.data.region ? res.data.region: null,
                    },
                    dataToAbout: {
                        history: res.data.history ? res.data.history : null,
                        dificulty: res.data.dificulty ? res.data.dificulty : null,
                        ingredients: res.data.ingredients ? res.data.ingredients : null,
                        media: res.data.media[2] ? res.data.media[2] : null,
                        number_people: res.data.number_people ? res.data.number_people : null,
                        time: res.data.time ? res.data.number_people : null,
                        preparation_time: res.data.time.preparation ? res.data.time.preparation : null,
                        cooking_time: res.data.time.cooking_time ? res.data.time.cooking_time : null,
                        source: res.data.source ? res.data.source : null,
                        region: res.data.region ? res.data.region: null,
                        observations: res.data.observations ? res.data.observations: null,
                        video_url: res.data.youtube_url ? res.data.youtube_url : null // video_url ex: "https://www.youtube.com/watch?v=ErPNkvLCDSQ"
                    },
                    dataToPreparation: {
                        preparation: res.data.preparation ? res.data.preparation : null
                    },
                    status: 1
                })
            }
        )
        .catch(
            err => {
                this.setState({
                    status: 2
                }, () => {
                    let path = this.props.match.path;
                    let url = path.replace('/:slug','');
                    this.props.history.push(url+'/404', url);
                })
            }
        )
    }

    render() {
        const {
            status,
            dataToBanner,
            dataToAbout,
            dataToPreparation
        } = this.state;

        const {
            t
        } = this.props;

        return(
            <DetailsPage>
                {
                    status === 0 &&
                        <SectionLoading>
                            <Loading/>
                        </SectionLoading>
                }
                {
                    status === 1 &&
                        <DetailsMaster>
                            <Banner type="2" t={t} data={dataToBanner}/>
                            <DetailsContent>
                                <About type="2" t={t} data={dataToAbout} qr url={window.location.href} img={dataToBanner.banner}/>
                                {
                                    dataToPreparation.preparation &&
                                        <span>
                                        {
                                            dataToPreparation.preparation.length > 1 &&
                                                <Preparation type="2" t={t} data={dataToPreparation}/>
                                        }
                                        </span>
                                }
                            </DetailsContent>
                            {/*
                                <RelatedReceips type="2" t={t}/>
                            */}
                        </DetailsMaster>
                }
            </DetailsPage>
        )
    }
}

export default translate('translations')(DetailsReceips);

// STYLES PAGE
const SectionLoading  = styled.div `
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background-color: white;
    z-index: 1000000000;
    display: flex;
    align-items: center;
`
const DetailsPage = styled.div `
`;
const DetailsMaster = styled.div `
`;
const DetailsContent = styled.div `
    padding-top: 70px;
`;



// WEBPACK FOOTER //
// ./src/pages/detailsReceips/detailsReceips.page.js